import { gql, useQuery } from "@apollo/client";
import {
  CustomerPointsOverviewQueryQuery,
  QueryCustomerPointsOverviewArgs,
} from "../../../../../schemaTypes";

export const CUSTOMER_POINTS_OVERVIEW_QUERY = gql`
  query CustomerPointsOverviewQuery($id: String!) {
    customerPointsOverview(id: $id) {
      customerTier
      pointBalance
      lifeTimePoint
    }
  }
`;

export const useCustomerPointsOverview = (
  variables: QueryCustomerPointsOverviewArgs
) => {
  const { data, loading, error, refetch } = useQuery<
    CustomerPointsOverviewQueryQuery,
    QueryCustomerPointsOverviewArgs
  >(CUSTOMER_POINTS_OVERVIEW_QUERY, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return {
    loading,
    error,
    refetch,
    customerTier: data?.customerPointsOverview?.customerTier ?? "",
    pointBalance: data?.customerPointsOverview?.pointBalance ?? 0,
    lifeTimePoint: data?.customerPointsOverview?.lifeTimePoint ?? 0,
  };
};